import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";

import ExitPollsBarGraph from "./ExitPollsBarGraph";
import { db } from '../../firebase';

interface TabulationData {
  totalVoters: number;
  tally: {
    [position: string]: {
      [candidate: string]: number;
    }
  }  
  [key: string]: any;
}

interface ExitPollsLocationProps {
  title: string;
  exitPollsValue: number;
  tabulationDocPath: string;
  position: string;
  candidate: string;
}

export const ExitPollsLocation: React.FC<ExitPollsLocationProps> = ({
  title,
  exitPollsValue,
  tabulationDocPath,
  position,
  candidate
}) => {
  const [tabulationData, setTabulationData] = useState<TabulationData | null>(null);
  
  useEffect(() => {
    const fetchTabulationData = async () => {
      try {
        const tabulationDocRef = doc(db, tabulationDocPath);
        const tabulationDocSnap = await getDoc(tabulationDocRef);

        if (tabulationDocSnap.exists()) {
          const data = tabulationDocSnap.data() as TabulationData;
          setTabulationData(data);
        }
      } catch (err) {
        console.error('Error fetching tabulation data', err);
      }
    };

    fetchTabulationData();
  }, [tabulationDocPath]);

  const data = tabulationData ? [
    { 
      label: 'Expected Votes', 
      color: '#82ca9d',
      value: tabulationData.tally[position][candidate] 
    },
    { 
      label: 'Exit Polls', 
      color: '#ffc658',
      value: exitPollsValue 
    }
  ] : [];

  return (
    <>
      {data.length > 0 && tabulationData && (
        <ExitPollsBarGraph
          title={title}
          total={tabulationData.totalVoters}
          totalLabel="Total Voters"
          data={data}
        />
      )}
    </>
  );
};
